import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { actions, type AppDispatch } from 'state';
import { hasUserNotification, type UserNotificationPathname } from '../user-notifications';
import useUser from './useUser';

interface ClearNotificationOnRouteOptions {
  routePathname?: string;
}

const useClearNotificationOnRoute = (
  notificationPathname: UserNotificationPathname,
  options: ClearNotificationOnRouteOptions = {}
) => {
  const dispatch = useDispatch<AppDispatch>();
  const { pathname } = useLocation();
  const user = useUser();
  const routePathname = options.routePathname ?? notificationPathname;

  useEffect(() => {
    if (pathname === routePathname && hasUserNotification(user, notificationPathname)) {
      dispatch(actions.users.clearNotification(notificationPathname));
    }
  }, [dispatch, notificationPathname, pathname, routePathname, user]);
};

export default useClearNotificationOnRoute;
